import { WsCore } from './ws.core';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../session.service';
import { IInternalClientInfo } from '../../../typings';
import { api2 } from './api2';

export class WsInternalClient extends WsCore {
     constructor(http: HttpClient, session: SessionService) {
          super(http, session);
     }

     me(): Promise<IInternalClientInfo> {
          return this.http
               .get(api2() + '/api/me', this._commonOptions({}))
               .toPromise() as any;
     }
}
